/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useEffect, useRef} from 'react';
import {ContentHeader} from '@components';
import {Form, Card, Tabs, Tab, Button, Table} from 'react-bootstrap';
import {DateTimePicker, DatePicker} from 'react-tempusdominus-bootstrap';
import Select from 'react-select';
import {useDispatch} from 'react-redux';
import {useNavigate, useParams, useLocation} from 'react-router-dom';
import {logoutUser} from '@store/reducers/auth';
import * as AuthService from '../../services/auth';
import {read, utils} from 'xlsx';
import {SelectedBox} from '../car/MapElement';
import {toast} from 'react-toastify';
import styled from 'styled-components';
import {PfImage} from '@profabric/react-components';
import {useSelector} from 'react-redux';
import {InputGroup} from 'react-bootstrap';
import SpinnerCustom from '@app/components/spinner/SpinnerCustom';

const ItemMember = (props: any) => {
  const StyledUserImage = styled(PfImage)``;
  return (
    <Card className="card bg-light">
      <Card.Body>
        <div className="col-12">
          <div className="row">
            <div className="col-2">
              <StyledUserImage
                src={props.img}
                fallbackSrc="/img/default-profile.png"
                width={48}
                height={48}
                rounded
              />
            </div>
            <div className="col-8">
              {`${props.index}. `} {props.name}
            </div>
            <div className="col-2">
              {props.mode === 'add' ? (
                <Button
                  className="btn-xs"
                  variant="outline-primary"
                  onClick={() => {
                    props.onAdd(props.empid, props.name, props.img);
                  }}
                >
                  &nbsp;&nbsp;เพิ่ม&nbsp;&nbsp;
                </Button>
              ) : (
                <Button
                  className="btn-xs"
                  variant="outline-primary"
                  onClick={() => {
                    props.onDelete(props.empid);
                  }}
                >
                  &nbsp;&nbsp;ลบ&nbsp;&nbsp;
                </Button>
              )}
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

const TrainingMake = () => {
  const user = useSelector((state: any) => state.auth.currentUser);
  const [error, setError] = useState('');
  const [key, setKey] = useState('training');
  const [dropdownExpense, setDropdownExpense] = useState<any>([]);
  const [dropdownGroup, setDropdownGroup] = useState<any>([]);
  const [dropdownTrainerType, setDropdownTrainerType] = useState<any>([]);
  const [dropdownPlace, setDropdownPlace] = useState<any>([]);
  const [dropdownType, setDropdownType] = useState<any>([]);
  const [members2, setMembers2] = useState<any>([]);
  const [members, setMembers] = useState<any>([]);
  const [min, setMin] = useState(null);
  const [search2, setSearch2] = useState<any>('');
  const [temp, setTemp] = useState<any>('');
  const [data, setData] = useState<any[]>([]);
  const [data3, setData3] = useState<any[]>([]);
  const [step, setStep] = useState<any>(1);
  const [stepTrainer, setStepTrainer] = useState<any>(1);
  const [max, setMax] = useState();
  const [show, setShow] = useState(false);
  const [checked, setChecked] = useState(false);

  const {id: copyId, report_id: reportId} = useParams();
  const newAddScroll = useRef<HTMLTableRowElement | null>(null);
  const duplicateScroll = useRef<HTMLTableRowElement | null>(null);
  const [newItem, setNewItem] = useState<number | null>(null);
  const [duplicateItem, setDuplicateItem] = useState<number | null>(null);
  const [search3, setSearch3] = useState('');
  const defaultTraining = {
    TRAINING_NAME: '',
    TRAINING_GROUP_NAME: '',
    TRAINING_DIVISION: '',
    TRAINING_FIELD: '',
    TRAINING_INSTRUCTOR: '',
    TRAINING_VENUE: '',
    TRAINING_DATE: new Date(),
    TRAINING_TIME_START: new Date(),
    TRAINING_TIME_END: new Date(),
    TRAINING_EXPIRED_DATE: null as Date | null,
    TRAINING_TOTAL_SCORE: 100,
    IS_ACTIVE: '',
    IS_CHECKED: false,
    IS_ADD_CALENDAR: false,
    TRAINING_ZOOM_URL: '',
    TRAINING_REG_START: new Date(),
    TRAINING_REG_END: new Date(),
    MAIL_SUBJECT: 'FYI : ขอเชิญเข้าร่วมหลักสูตรการอบรมภายใน (By HRD)',
    MAIL_BODY:
      'ตามที่ฝ่าย HRD ได้ทำการสร้างหลักสูตรการอบรมและเชิญท่านเข้าร่วมอบรมโดยรายละเอียดดังตารางด้านล่างนี้',
    TRAINING_TYPE: '',
    TRAINING_GROUP: '',
    TRAINING_INSTRUCTOR_TYPE: '',
    TRAINING_INSTRUCTOR_NAME: '',
    TRAINING_TYPE_V2: '',
    TRAINING_PLACE: '',
    TRAINING_RATING: 0,
    TRAINING_DOC_URL: '',
    TRAINING_HOUR: 0,
    TRAINEE: [],
    TRAINER: [],
    EXPENSE: [],
    TRAINING_COMMENT: '',
    TRAINING_CERT_NO: ''
  };
  const [training, setTraining] = useState(defaultTraining);
  const [isLoading, setIsLoading] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isCheckingAdmin, setIsCheckingAdmin] = useState(true);

  useEffect(() => {
    const checkAccessAndLoad = async () => {
      setIsCheckingAdmin(true);
      try {
        await downloadDropdownWs(); // ยังโหลดได้แม้ไม่ใช่ HRD

        const res = await AuthService.downloadHrdWs();
        if (res?.error) {
          toast.error(res.error);
        }

        const allowed = res?.value === true;
        setIsAdmin(allowed); // จะใช้ isAdmin ต่อ

        if (allowed) {
          await init(); // โหลด training/report เมื่อเป็น HRD
        }
      } catch (err) {
        console.error('Error in checkAccessAndLoad:', err);
        setIsAdmin(false);
      } finally {
        setIsCheckingAdmin(false);
      }
    };

    checkAccessAndLoad();
  }, [copyId, reportId]);

  const init = async () => {
    setIsLoading(true);
    try {
      if (copyId && reportId) {
        const trainingData = await fetchCopyTraining(copyId);
        const reportDataArray = await fetchCopyTrainingData(copyId, reportId);
        const reportData =
          Array.isArray(reportDataArray) && reportDataArray.length > 0
            ? reportDataArray[0]
            : {};

        const fieldsToExclude = [
          'TRAINING_HOUR',
          'TRAINING_TOTAL_SCORE',
          'TRAINING_DATE',
          'TRAINING_TIME_END',
          'TRAINING_TIME_START',
          'TRAINING_REG_START',
          'TRAINING_REG_END',
          'TRAINING_EXPIRED_DATE',
          'TRAINING_EXPIRED_DT',
          'EXPENSE',
          'RELATED',
          'TRAINER'
        ];

        const cleanedTrainingData = removeFields(trainingData, fieldsToExclude);
        const cleanedReportData = removeFields(reportData, fieldsToExclude);

        setTraining((prevState) => ({
          ...prevState,
          ...cleanedReportData,
          ...cleanedTrainingData
        }));

        if (trainingData.TRAINEE && trainingData.TRAINEE.length > 0) {
          const activeTrainees = trainingData.TRAINEE.filter(
            (trainee) => !trainee.NAME || !trainee.NAME.includes('[ลาออก]')
          );
          setData(activeTrainees);
          setStep(2);
        }
      } else {
        setTraining(defaultTraining);
        setData([]);
        setStep(1);
      }
    } catch (error) {
      console.error('Error combining copy data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (newItem) {
      setTimeout(() => {
        if (newAddScroll.current) {
          newAddScroll.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }, 100);
    }
  }, [newItem]);

  useEffect(() => {
    if (duplicateItem) {
      setTimeout(() => {
        if (duplicateScroll.current) {
          duplicateScroll.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }, 100);
    }
  }, [duplicateItem]);

  const fetchCopyTraining = async (id: string) => {
    try {
      const res = await downloadTraineeAndExpense(id);
      return {
        TRAINEE: res.TRAINEE || [],
        TRAINER: res.TRAINER || [],
        RELATED: res.RELATED || [],
        EXPENSE: res.EXPENSE || [],
        SCORE: res.SCORE || []
      };
    } catch (error) {
      console.error(error);
      return {
        TRAINEE: [],
        TRAINER: [],
        RELATED: [],
        EXPENSE: [],
        SCORE: []
      };
    }
  };

  const fetchCopyTrainingData = async (id: string, report_id: string) => {
    const payload = {
      report_id,
      training_id: id
    };
    try {
      const res = await AuthService.downloadReportCourse(payload);
      if (Array.isArray(res) && res.length > 0) {
        return res;
      } else {
        console.warn('No data in reportDataArray');
        return [];
      }
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const downloadTraineeAndExpense = async (training_id: any) => {
    try {
      const result = await AuthService.downloadHrdTraineeAndExpense(
        training_id
      );
      return result;
    } catch (error) {
      dispatch(logoutUser());
      window.location.href = '/login';
      return {
        TRAINEE: [],
        TRAINER: [],
        EXPENSE: [],
        SCORE: [],
        RELATED: []
      };
    }
  };

  const removeFields = (obj: any, fields: string[]) => {
    const result = {...obj};
    fields.forEach((field) => {
      if (field in result) {
        delete result[field];
      }
    });
    return result;
  };

  const handleValidation = () => {
    let errors = '';
    let formIsValid = true;

    if (training.TRAINING_NAME === '') {
      formIsValid = false;
      errors = errors + 'ชื่อหลักสูตร, ';
    }
    if (training.TRAINING_GROUP_NAME === '') {
      formIsValid = false;
      errors = errors + 'ตำแหน่งผู้เรียน, ';
    }
    if (training.TRAINING_DIVISION === '') {
      formIsValid = false;
      errors = errors + 'ฝ่ายงานผู้เรียน, ';
    }
    if (training.TRAINING_FIELD === '') {
      formIsValid = false;
      errors = errors + 'สายงานของผู้เรียน, ';
    }
    if (training.TRAINING_INSTRUCTOR === '') {
      formIsValid = false;
      errors = errors + 'วิทยากร, ';
    }
    if (training.TRAINING_VENUE === '') {
      formIsValid = false;
      errors = errors + 'สถานที่, ';
    }
    if (training.TRAINING_GROUP === '') {
      formIsValid = false;
      errors = errors + 'หมวดหลักสูตร, ';
    }
    if (training.TRAINING_INSTRUCTOR_TYPE === '') {
      formIsValid = false;
      errors = errors + 'ประเภทวิทยากร, ';
    }
    if (training.TRAINING_TYPE_V2 === '') {
      formIsValid = false;
      errors = errors + 'รูปแบบการจัด, ';
    }
    if (training.TRAINING_PLACE === '') {
      formIsValid = false;
      errors = errors + 'ประเภทการจัด, ';
    }
    if (training.TRAINEE.length == 0) {
      formIsValid = false;
      errors = errors + 'ผู้เข้าอบรมอย่างน้อย 1 คน, ';
    }

    if (!formIsValid) setError(`Required: ${errors}`);
    else setError('');
    return formIsValid;
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const fileUpload = async (e: any) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      let res1 = await validateFile(file);
      if (res1.length > 0) {
        let _res1 = await getFullData(res1);

        //เรียงตาม res1
        let item_order = res1.map((e) => `${e.EMPID}`);
        _res1 = mapOrder(_res1, item_order);

        setData(_res1);
        setTraining((prevState: any) => ({
          ...prevState,
          TRAINEE: _res1
        }));
        setStep(2);
      } else {
        toast.error('Wrong file format!');
      }
    }
    e.target.value = null;
  };

  function mapOrder(array: any, order: any) {
    array.sort(function (a: any, b: any) {
      var A = a['EMPID'],
        B = b['EMPID'];
      if (order.indexOf(A) > order.indexOf(B)) {
        return 1;
      } else {
        return -1;
      }
    });
    return array;
  }

  const onSearch2 = async () => {
    if (search2 === '') {
      toast.warning('กรุณาใส่คำค้นหา');
    } else {
      const _members = await AuthService.downloadEmployees(search2);
      setMembers2(_members);
    }
  };

  const onHistory = async () => {
    const _members = await AuthService.downloadLastRelated();
    setMembers(_members);
  };

  const onAdd = async (empid: any, name: any, img: any) => {
    if (empid === user.ID_EMP) {
      toast.warning('ไม่ต้องเพิ่มตัวเอง');
    } else {
      if (members.find((e: any) => e.ID_Emp === empid)) {
        toast.warning('รายการซ้ำ ไม่สามารถเพิ่มได้');
      } else {
        let _temp = [
          ...members,
          {DisplayName: name, ID_Emp: empid, Image: img}
        ];
        setMembers(_temp);
      }
    }
  };

  const onDelete = async (empid: any) => {
    if (members.find((e: any) => e.ID_Emp === empid)) {
      let _temp = members.filter((e: any) => e.ID_Emp !== empid);
      setMembers(_temp);
    } else {
      toast.warning('ไม่พบข้อมูล');
    }
  };

  const handleDelete = (indexToDelete: number) => {
    setData((prev) => {
      const updated = prev.filter((_, idx) => idx !== indexToDelete);
      setTraining((prevTraining: any) => ({
        ...prevTraining,
        TRAINEE: updated
      }));
      return updated;
    });
  };

  const handleAddTrainee = async () => {
    const empid = search3.trim();

    if (!empid) {
      toast.warn('กรุณากรอกรหัสพนักงานก่อนเพิ่ม');
      return;
    }

    try {
      const payload = [
        {
          EMPID: empid
        }
      ];
      const res = await getFullData(payload);
      if (!res || res.length === 0) {
        toast.warn(`ไม่พบรหัสพนักงาน ${empid} ในระบบ`);
        return;
      }

      const employee = res[0];

      const existingIndex = data.findIndex(
        (item) => item.EMPID === employee.EMPID
      );
      if (existingIndex !== -1) {
        setDuplicateItem(existingIndex);
        setTimeout(() => setDuplicateItem(null), 3000);
        toast.warn(`รหัสพนักงาน ${employee.EMPID} มีอยู่แล้วในรายการ`);
        return;
      }

      const newIndex = data.length;
      setData((prev) => {
        const updated = [...prev, employee];
        setTraining((prevTraining: any) => ({
          ...prevTraining,
          TRAINEE: updated
        }));
        return updated;
      });
      setNewItem(newIndex);
      setTimeout(() => setNewItem(null), 3000);
      toast.success(`เพิ่ม ${employee.EMPID} - ${employee.NAME} สำเร็จ`);
      setSearch3('');
    } catch (error) {
      console.error(error);
      toast.error('เกิดข้อผิดพลาดขณะเพิ่มพนักงาน');
    }
  };

  const fileUpload3 = async (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      let res1 = await validateFile(file);
      if (res1.length > 0) {
        let _res1 = await getFullData(res1);
        _res1 = _res1.map((e: any, i: any) => {
          if (i === 0) return {...e, IS_MAIN: true};
          else return {...e, IS_MAIN: false};
        });

        const names = _res1.reduce((prev: any, curr: any) => {
          return `${prev}คุณ${curr.NAME}, `;
        }, '');

        setData3(_res1);
        setTraining((prevState: any) => ({
          ...prevState,
          TRAINING_INSTRUCTOR: names,
          TRAINER: _res1
        }));
        setStepTrainer(2);
      } else {
        toast.error('Wrong file format!');
      }
    }
    e.target.value = null;
  };

  interface Trainee {
    EMPID: string;
  }

  const validateFile = async (file: File) => {
    try {
      const data = await file.arrayBuffer();
      const workbook = read(data);
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      let jsonData = utils.sheet_to_json<Trainee>(worksheet);
      jsonData = jsonData.map((e, i) => ({
        ...e,
        index: i + 1
      }));
      if (!jsonData[0].hasOwnProperty('EMPID')) {
        throw 'error';
      }
      return jsonData;
    } catch {
      return [];
    }
  };

  const getFullData = async (employees: any) => {
    try {
      const _res = await AuthService.getEmployees(employees);
      return _res;
    } catch (error: any) {
      return [];
    }
  };

  const onValueChange = (index, value) => {
    let temp = training.EXPENSE.map((e: any) => {
      if (e.value === index) return {...e, amount: parseInt(value)};
      else return e;
    });

    setTraining((prevState: any) => ({
      ...prevState,
      EXPENSE: temp
    }));
  };

  const downloadDropdownWs = async () => {
    try {
      const dropdowns = await AuthService.downloadDropdownHrd();
      if (dropdowns.error) throw 'timeout';

      //COMP, BOSS
      if (Object.keys(dropdowns).length !== 0) {
        setDropdownExpense(
          dropdowns.dropdown.filter(
            (e: any) => e.DDL_TYPE === 'TRAINING_EXPENSE'
          )
        );
        setDropdownGroup(
          dropdowns.dropdown.filter((e: any) => e.DDL_TYPE === 'TRAINING_GROUP')
        );
        setDropdownTrainerType(
          dropdowns.dropdown.filter(
            (e: any) => e.DDL_TYPE === 'TRAINING_INSTRUCTOR_TYPE'
          )
        );
        setDropdownPlace(
          dropdowns.dropdown.filter((e: any) => e.DDL_TYPE === 'TRAINING_PLACE')
        );
        setDropdownType(
          dropdowns.dropdown.filter(
            (e: any) => e.DDL_TYPE === 'TRAINING_TYPE_V2'
          )
        );
      }
    } catch (error: any) {
      dispatch(logoutUser());
      navigate('/login');
      window.location.href = '/login';
    }
  };

  function addDays(date: any, days: number) {
    // var result = new Date(date);
    date.setDate(date.getDate() + days);
    return date;
  }

  const handleSubmit = async () => {
    const offset = training.TRAINING_DATE.getTimezoneOffset();
    const thDate1 = new Date(
      training.TRAINING_DATE.getTime() - offset * 60 * 1000
    );
    const thDate2 = new Date(
      training.TRAINING_TIME_START.getTime() - offset * 60 * 1000
    );
    const thDate3 = new Date(
      training.TRAINING_TIME_END.getTime() - offset * 60 * 1000
    );

    const thDate4 = new Date(
      training.TRAINING_REG_START.getTime() - offset * 60 * 1000
    );
    const thDate5 = new Date(
      training.TRAINING_REG_END.getTime() - offset * 60 * 1000
    );

    const thDate6 = training.TRAINING_EXPIRED_DATE
      ? new Date(
          (training.TRAINING_EXPIRED_DATE as Date).getTime() -
            offset * 60 * 1000
        )
      : null;

    if (handleValidation()) {
      try {
        const input = {
          ...training,
          RELATED: members,
          isAddCalendar: training.IS_ADD_CALENDAR,
          TRAINING_DATE: thDate1.toISOString().split('T')[0],
          TRAINING_TIME_START: thDate2
            .toISOString()
            .split('T')[1]
            .substring(0, 5),
          TRAINING_TIME_END: thDate3
            .toISOString()
            .split('T')[1]
            .substring(0, 5),
          TRAINING_REG_START: thDate4
            .toISOString()
            .replaceAll('T', ' ')
            .substring(0, 19),
          TRAINING_REG_END: thDate5
            .toISOString()
            .replaceAll('T', ' ')
            .substring(0, 19),
          TRAINING_EXPIRED_DATE: thDate6
            ? thDate6.toISOString().split('T')[0]
            : null
        };
        const result = await AuthService.addTraining(input);

        if (result.error) throw result.error;
        toast.success('เพิ่มหลักสูตรสำเร็จแล้ว');
        navigate('/hrd-report');
      } catch (error: any) {
        toast.error(error);
      }
    }
  };

  const handleReupload = async () => {
    setStep(1);
    setStepTrainer(1);
    setData([]);
    setData3([]);
  };

  return (
    <div>
      <ContentHeader title="Add Training" />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-md-12">
              {isCheckingAdmin && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'rgba(255,255,255,0.7)',
                    zIndex: 10
                  }}
                >
                  <SpinnerCustom />
                </div>
              )}
              {isAdmin && isLoading && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'rgba(255,255,255,0.7)',
                    zIndex: 10
                  }}
                >
                  <SpinnerCustom />
                </div>
              )}
              {!isCheckingAdmin && !isAdmin && (
                <div
                  className="overlay dark"
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(0, 0, 0, 0.6)',
                    zIndex: 10,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '0.375rem'
                  }}
                >
                  <span style={{color: 'white', fontSize: 30}}>HRD ONLY</span>
                </div>
              )}
              <Card className="card-primary">
                <Card.Body>
                  <Tabs
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k: any) => setKey(k)}
                    className="mb-3"
                  >
                    <Tab eventKey="training" title="กรอกข้อมูล (1)">
                      <div className="row">
                        <Form.Group className="mb-2 col-md-6">
                          <Form.Control
                            as="textarea"
                            // type="text"
                            value={training.TRAINING_NAME}
                            placeholder={'หัวข้อการอบรม/ชื่อหลักสูตร'}
                            onChange={(e) => {
                              setTraining((prevState) => ({
                                ...prevState,
                                TRAINING_NAME: e.target.value
                              }));
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-2 col-md-6">
                          <Form.Control
                            as="textarea"
                            // type="text"
                            value={training.TRAINING_GROUP_NAME}
                            // placeholder={'กลุ่มอบรม'}
                            placeholder={'ตำแหน่งผู้เรียน'}
                            onChange={(e) => {
                              setTraining((prevState) => ({
                                ...prevState,
                                TRAINING_GROUP_NAME: e.target.value
                              }));
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-2 col-md-6">
                          <Form.Control
                            as="textarea"
                            // type="text"
                            value={training.TRAINING_DIVISION}
                            placeholder={'ฝ่ายงานผู้เรียน'}
                            onChange={(e) => {
                              setTraining((prevState) => ({
                                ...prevState,
                                TRAINING_DIVISION: e.target.value
                              }));
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-2 col-md-6">
                          <Form.Control
                            as="textarea"
                            // type="text"
                            value={training.TRAINING_FIELD}
                            placeholder={'สายงานของผู้เรียน'}
                            onChange={(e) => {
                              setTraining((prevState) => ({
                                ...prevState,
                                TRAINING_FIELD: e.target.value
                              }));
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-2 col-md-6">
                          <Form.Control
                            type="text"
                            disabled={
                              Number(training.TRAINING_INSTRUCTOR_TYPE) === 1
                            }
                            value={training.TRAINING_INSTRUCTOR}
                            placeholder={
                              Number(training.TRAINING_INSTRUCTOR_TYPE) === 1
                                ? 'ชื่อวิทยากรจะมาอัตโนมัติ'
                                : 'ชื่อวิทยากร'
                            }
                            onChange={(e) => {
                              setTraining((prevState) => ({
                                ...prevState,
                                TRAINING_INSTRUCTOR: e.target.value
                              }));
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-2 col-md-6">
                          <Form.Control
                            type="text"
                            value={training.TRAINING_VENUE}
                            placeholder={'สถานที่อบรม'}
                            onChange={(e) => {
                              setTraining((prevState) => ({
                                ...prevState,
                                TRAINING_VENUE: e.target.value
                              }));
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-2 col-md-6">
                          <Select
                            value={dropdownGroup.filter(
                              (e) => e.value === training.TRAINING_GROUP
                            )}
                            placeholder={'หมวดหลักสูตร'}
                            options={dropdownGroup}
                            onChange={(v: any) =>
                              setTraining((prevState) => ({
                                ...prevState,
                                TRAINING_GROUP: v.value
                              }))
                            }
                          />
                        </Form.Group>
                        <Form.Group className="mb-2 col-md-3">
                          <Select
                            value={dropdownTrainerType.filter(
                              (e) =>
                                e.value === training.TRAINING_INSTRUCTOR_TYPE
                            )}
                            placeholder={'ประเภทวิทยากร'}
                            options={dropdownTrainerType}
                            onChange={(v: any) => {
                              setTraining((prevState) => ({
                                ...prevState,
                                TRAINING_INSTRUCTOR_TYPE: v.value,
                                TRAINING_INSTRUCTOR_NAME:
                                  Number(v.value) === 2
                                    ? prevState.TRAINING_INSTRUCTOR_NAME
                                    : ''
                              }));
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-2 col-md-3">
                          <Form.Control
                            type="text"
                            disabled={
                              Number(training.TRAINING_INSTRUCTOR_TYPE) === 1
                            }
                            value={training.TRAINING_INSTRUCTOR_NAME}
                            placeholder={'ชื่อสถาบัน/บริษัทวิทยากร'}
                            onChange={(e) => {
                              setTraining((prevState) => ({
                                ...prevState,
                                TRAINING_INSTRUCTOR_NAME: e.target.value
                              }));
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-2 col-md-6">
                          <Select
                            value={dropdownType.filter(
                              (e) => e.value === training.TRAINING_TYPE_V2
                            )}
                            placeholder={'รูปแบบการจัด'}
                            options={dropdownType}
                            onChange={(v: any) =>
                              setTraining((prevState) => ({
                                ...prevState,
                                TRAINING_TYPE_V2: v.value,
                                TRAINING_TYPE: v.value === '2' ? 'ON' : 'OFF'
                              }))
                            }
                          />
                        </Form.Group>
                        <Form.Group className="mb-2 col-md-3">
                          <Select
                            value={dropdownPlace.filter(
                              (e) => e.value === training.TRAINING_PLACE
                            )}
                            placeholder={'ประเภทการจัดอบรม'}
                            options={dropdownPlace}
                            onChange={(v: any) =>
                              setTraining((prevState) => ({
                                ...prevState,
                                TRAINING_PLACE: v.value
                              }))
                            }
                          />
                        </Form.Group>
                        <Form.Group className="mb-2 col-md-3">
                          <Form.Control
                            type="text"
                            value={training.TRAINING_CERT_NO}
                            placeholder={'Certificate No.'}
                            onChange={(e) => {
                              setTraining((prevState) => ({
                                ...prevState,
                                TRAINING_CERT_NO: e.target.value
                              }));
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-2 col-md-4">
                          <Form.Label>วันเวลาเริ่มอบรม</Form.Label>
                          <DateTimePicker
                            // disable={true}
                            // readOnly={true}
                            // showPickerIfReadOnly={true}
                            date={training.TRAINING_DATE}
                            // defaultDate={training.TRAINING_DATE}
                            format="YYYY-MM-DD HH:mm"
                            onChange={async (e: any) => {
                              const startDate = e.date.toDate();
                              setTraining((prevState) => {
                                const expiredDate = new Date(startDate);
                                expiredDate.setFullYear(
                                  expiredDate.getFullYear() + 1
                                );
                                expiredDate.setDate(expiredDate.getDate() - 1);
                                expiredDate.setHours(0, 0, 0, 0);

                                const endDate = new Date(startDate);
                                return {
                                  ...prevState,
                                  TRAINING_DATE: startDate,
                                  TRAINING_TIME_START: startDate,
                                  TRAINING_TIME_END: endDate,
                                  TRAINING_EXPIRED_DATE: prevState.IS_CHECKED
                                    ? expiredDate
                                    : prevState.TRAINING_EXPIRED_DATE
                                };
                              });
                              setMin(e.date.toDate());
                              setMax(
                                addDays(e.date.toDate(), 1)
                                  ? addDays(e.date.toDate(), 1)
                                  : e.date.toDate()
                              );
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-2 col-md-4">
                          <Form.Label>
                            วันเวลาที่สิ้นสุดอบรม (ให้เลือกวันเดียวกัน)
                          </Form.Label>
                          <DateTimePicker
                            // readOnly={true}
                            // showPickerIfReadOnly={true}
                            // disable={true}
                            // minDate={min}
                            // maxDate={max}
                            date={training.TRAINING_TIME_END}
                            format="YYYY-MM-DD HH:mm"
                            onChange={async (e: any) => {
                              setTraining((prevState: any) => {
                                let hours =
                                  Math.round(
                                    (Math.abs(
                                      prevState.TRAINING_DATE - e.date.toDate()
                                    ) /
                                      36e5) *
                                      2
                                  ) / 2;

                                hours =
                                  prevState.TRAINING_DATE.getHours() <= 12 &&
                                  e.date.toDate().getHours() >= 13
                                    ? hours - 1
                                    : hours;
                                return {
                                  ...prevState,
                                  TRAINING_HOUR: hours,
                                  TRAINING_TIME_END: e.date.toDate()
                                };
                              });
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-2 col-md-2">
                          <Form.Label>รวมชั่วโมง</Form.Label>
                          <Form.Control
                            type="number"
                            value={training.TRAINING_HOUR}
                            placeholder={'ชั่วโมงเรียน'}
                            onChange={(e) => {
                              setTraining((prevState) => ({
                                ...prevState,
                                TRAINING_HOUR: Number(e.target.value)
                              }));
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-2 col-md-2">
                          <Form.Label>คะแนนเต็ม</Form.Label>
                          <Form.Control
                            type="number"
                            value={training.TRAINING_TOTAL_SCORE}
                            placeholder={'คะแนนเต็ม'}
                            onChange={(e) => {
                              setTraining((prevState) => ({
                                ...prevState,
                                TRAINING_TOTAL_SCORE: Number(e.target.value)
                              }));
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-2 col-md-4">
                          <Form.Label>วันที่เปิดลงนามผ่านแอฟฯ</Form.Label>
                          <DateTimePicker
                            // readOnly={true}
                            // showPickerIfReadOnly={true}
                            // disable={true}
                            date={training.TRAINING_REG_START}
                            format="YYYY-MM-DD HH:mm"
                            onChange={async (e: any) => {
                              setTraining((prevState) => {
                                return {
                                  ...prevState,
                                  TRAINING_REG_START: e.date.toDate()
                                };
                              });
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-2 col-md-4">
                          <Form.Label>วันที่สิ้นสุดลงนามผ่านแอฟฯ</Form.Label>
                          <DateTimePicker
                            // readOnly={true}
                            // showPickerIfReadOnly={true}
                            // disable={true}
                            date={training.TRAINING_REG_END}
                            format="YYYY-MM-DD HH:mm"
                            onChange={async (e: any) => {
                              setTraining((prevState) => {
                                return {
                                  ...prevState,
                                  TRAINING_REG_END: e.date.toDate()
                                };
                              });
                            }}
                          />
                        </Form.Group>

                        <Form.Group className="mb-2 col-md-4">
                          <Form.Label>วันหมดอายุของหลักสูตร</Form.Label>
                          <InputGroup className="mb-3">
                            <div className="custom-datetime-picker">
                              <DateTimePicker
                                readOnly={!training.IS_CHECKED}
                                date={training.TRAINING_EXPIRED_DATE}
                                format="YYYY-MM-DD"
                                onChange={async (e: any) => {
                                  setTraining((prevState) => {
                                    return {
                                      ...prevState,
                                      TRAINING_EXPIRED_DATE: e.date.toDate()
                                    };
                                  });
                                }}
                              />
                            </div>

                            <InputGroup.Text
                              style={{
                                borderRadius: '0rem 0.25rem 0.25rem 0rem',
                                borderLeft: 'none'
                              }}
                            >
                              <Form.Check
                                type="checkbox"
                                checked={training.IS_CHECKED}
                                onChange={(e) => {
                                  const isChecked = e.target.checked;
                                  if (isChecked) {
                                    const expiredDate = new Date(
                                      training.TRAINING_DATE || new Date()
                                    );
                                    expiredDate.setFullYear(
                                      expiredDate.getFullYear() + 1
                                    );
                                    expiredDate.setDate(
                                      expiredDate.getDate() - 1
                                    );
                                    expiredDate.setHours(0, 0, 0, 0);

                                    setTraining((prevState) => ({
                                      ...prevState,
                                      TRAINING_EXPIRED_DATE: expiredDate as any,
                                      IS_CHECKED: isChecked
                                    }));
                                  } else {
                                    setTraining((prevState) => ({
                                      ...prevState,
                                      TRAINING_EXPIRED_DATE: null as any,
                                      IS_CHECKED: isChecked
                                    }));
                                  }
                                }}
                              />
                            </InputGroup.Text>
                          </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-2 col-md-12">
                          <Form.Control
                            type="text"
                            value={training.TRAINING_ZOOM_URL}
                            placeholder={'Link Zoom (ถ้ามี)'}
                            onChange={(e) => {
                              setTraining((prevState) => ({
                                ...prevState,
                                TRAINING_ZOOM_URL: e.target.value
                              }));
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-2 col-md-12">
                          <Form.Control
                            type="text"
                            value={training.TRAINING_DOC_URL}
                            placeholder={'Link เอกสาร (ถ้ามี)'}
                            onChange={(e) => {
                              setTraining((prevState) => ({
                                ...prevState,
                                TRAINING_DOC_URL: e.target.value
                              }));
                            }}
                          />
                        </Form.Group>
                        <div
                          className={`prime-checkbox-wrapper ${
                            training.IS_ADD_CALENDAR ? 'checked' : ''
                          }`}
                        >
                          <Form.Check
                            type="checkbox"
                            id="calendar-appointment"
                            checked={training.IS_ADD_CALENDAR}
                            onChange={(e) =>
                              setTraining({
                                ...training,
                                IS_ADD_CALENDAR: e.target.checked
                              })
                            }
                            label="เพิ่มนัดหมายลงปฎิทินของผู้เข้าร่วมอบรม"
                            className="prime-style-checkbox"
                          />
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="trainee" title="ผู้เข้าอบรม (2)">
                      <div className="container-fluid">
                        <div
                          className={
                            step === 1
                              ? 'card card-primary'
                              : 'card collapsed-card'
                          }
                        >
                          <div className="card-header">
                            <h3 className="card-title">
                              ขั้นตอนที่ 1 : อัพโหลด Excel
                            </h3>
                            <div className="card-tools">
                              <button
                                onClick={() => {
                                  window
                                    .open(
                                      'https://api-passport.advanceagro.net/file/Training.xlsx',
                                      '_blank'
                                    )
                                    ?.focus();
                                }}
                                type="button"
                                className="btn btn-tool"
                              >
                                <i className="fa fa-file-csv" />
                              </button>
                            </div>
                          </div>
                          <div
                            className={
                              step === 1 ? 'card-body' : 'card-body d-none'
                            }
                          >
                            <Form.Group className="mb-3 col-md-9">
                              <Form.Control
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={fileUpload}
                              />
                            </Form.Group>
                          </div>
                        </div>

                        <div
                          className={
                            step === 2
                              ? 'card card-primary'
                              : 'card collapsed-card'
                          }
                        >
                          <div className="card-header">
                            <h3 className="card-title">
                              ขั้นตอนที่ 2 : ตรวจความถูกต้อง
                            </h3>
                          </div>

                          <div
                            className={
                              step === 2 ? 'card-header bg-light' : 'd-none'
                            }
                          >
                            <div className="row align-items-center">
                              <div className="col-md-5">
                                <div className="input-group">
                                  <input
                                    value={search3}
                                    type="text"
                                    onChange={(event) => {
                                      event.preventDefault();
                                      setSearch3(event.target.value);
                                    }}
                                    className="form-control"
                                    placeholder="รหัสพนักงาน"
                                    style={{
                                      borderTopRightRadius: 0,
                                      borderBottomRightRadius: 0
                                    }}
                                  />
                                  <Button
                                    variant="info"
                                    onClick={handleAddTrainee}
                                    className="input-group-text border-0"
                                    style={{
                                      borderTopLeftRadius: 0,
                                      borderBottomLeftRadius: 0,
                                      backgroundColor: '#17a2b8',
                                      color: 'white',
                                      cursor: 'pointer'
                                    }}
                                  >
                                    <i
                                      className="fas fa-user-plus"
                                      style={{marginRight: '10px'}}
                                    ></i>
                                    เพิ่ม 1 คน
                                  </Button>
                                </div>
                              </div>
                              <div className="col-md-3 offset-4">
                                <Button
                                  variant="warning"
                                  block
                                  type="button"
                                  onClick={handleReupload}
                                >
                                  <i
                                    className="fas fa-upload me-2"
                                    style={{marginRight: '10px'}}
                                  ></i>
                                  ไม่ถูกต้อง, อัพโหลดใหม่
                                </Button>
                              </div>
                            </div>
                          </div>

                          <div
                            className={
                              step === 2 ? 'card-body p-0' : 'card-body d-none'
                            }
                            style={{
                              maxHeight: 'calc(100vh - 35.3rem)',
                              width: '100%',
                              overflowY: 'auto'
                            }}
                          >
                            <Table striped className="mb-0">
                              <thead
                                className="position-sticky bg-white"
                                style={{top: 0, zIndex: 10}}
                              >
                                <tr>
                                  <th style={{width: '60px'}}>#</th>
                                  <th style={{width: '100px'}}>รหัสพนักงาน</th>
                                  <th style={{width: '200px'}}>ชื่อ-สกุล</th>
                                  <th style={{width: '120px'}}>กลุ่ม</th>
                                  <th style={{width: '150px'}}>แผนก</th>
                                  <th style={{width: '180px'}}>บริษัท</th>
                                  <th style={{width: '50px'}}>ลบ</th>
                                </tr>
                              </thead>
                              <tbody>
                                {data.map((x, i) => {
                                  // เช็คว่าเป็นแถวที่ซ้ำหรือไม่
                                  const isDuplicate = duplicateItem === i;
                                  // เช็คว่าเป็นแถวที่เพิ่มใหม่หรือไม่
                                  const isNewlyAdded = newItem === i;

                                  return (
                                    <tr
                                      key={`v-${i}`}
                                      ref={
                                        isNewlyAdded
                                          ? newAddScroll
                                          : isDuplicate
                                          ? duplicateScroll
                                          : null
                                      }
                                      className={
                                        isNewlyAdded
                                          ? 'table-success animate-highlight-green'
                                          : isDuplicate
                                          ? 'table-danger animate-highlight-red'
                                          : ''
                                      }
                                      style={{
                                        transition:
                                          'background-color 0.3s ease',
                                        ...(isNewlyAdded && {
                                          backgroundColor: '#d4edda',
                                          animation:
                                            'highlightGreen 3s ease-out forwards'
                                        }),
                                        ...(isDuplicate && {
                                          backgroundColor: '#f8d7da',
                                          animation:
                                            'highlightRed 3s ease-out forwards'
                                        })
                                      }}
                                    >
                                      <td>{i + 1}</td>
                                      <td>{x['EMPID']}</td>
                                      <td>{x['NAME']}</td>
                                      <td>{x['SECTION']}</td>
                                      <td>{x['DEPARTMENT']}</td>
                                      <td>{x['COMPANY']}</td>
                                      <td>
                                        <a>
                                          <i
                                            className="fas fa-trash text-danger"
                                            style={{cursor: 'pointer'}}
                                            onClick={() => handleDelete(i)}
                                          />
                                        </a>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </Table>
                          </div>
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="email" title="หัวข้ออีเมล (3)">
                      <div className="row">
                        <Form.Group className="mb-2 col-md-12">
                          <Form.Control
                            as="textarea"
                            // type="text"
                            value={training.MAIL_SUBJECT}
                            placeholder={'หัวในอีเมล'}
                            onChange={(e) => {
                              setTraining((prevState) => ({
                                ...prevState,
                                MAIL_SUBJECT: e.target.value
                              }));
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-2 col-md-12">
                          <Form.Control
                            as="textarea"
                            // type="text"
                            value={training.MAIL_BODY}
                            placeholder={'ข้อความส่วนต้นอีเมล'}
                            onChange={(e) => {
                              setTraining((prevState) => ({
                                ...prevState,
                                MAIL_BODY: e.target.value
                              }));
                            }}
                          />
                        </Form.Group>
                      </div>
                    </Tab>
                    <Tab eventKey="expense" title="ค่าใช้จ่าย (4)">
                      <div className="row">
                        <Form.Group className="mb-3 col-md-12">
                          <Select
                            isMulti
                            value={training.EXPENSE}
                            // menuPlacement="top"
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder={'ค่าใช้จ่ายอื่นๆ'}
                            options={dropdownExpense}
                            onChange={(v: any) => {
                              const _temp = v.map((e) => ({
                                ...e,
                                amount: 0,
                                selected: true,
                                unit: 'บาท'
                              }));
                              setTraining((prevState) => ({
                                ...prevState,
                                EXPENSE: _temp
                              }));
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-3 col-md-12">
                          <SelectedBox
                            selected={training.EXPENSE}
                            onValueChange={onValueChange}
                          />
                        </Form.Group>
                      </div>
                    </Tab>
                    <Tab
                      eventKey="trainer-inhouse"
                      title="วิทยากรภายใน (5)"
                      disabled={
                        training.TRAINING_INSTRUCTOR_TYPE === '' ||
                        Number(training.TRAINING_INSTRUCTOR_TYPE) === 2
                      }
                    >
                      <div className="container-fluid">
                        <div className="row">
                          <div className="col-md-12">
                            <div
                              className={
                                stepTrainer === 1
                                  ? 'card card-primary'
                                  : 'card collapsed-card'
                              }
                            >
                              <div className="card-header">
                                <h3 className="card-title">
                                  ขั้นตอนที่ 1 : อัพโหลด Excel
                                  (รายการเก่าจะหายและถูกแทนที่ด้วยของใหม่ทั้งหมด)
                                </h3>
                                <div className="card-tools">
                                  <button
                                    onClick={() => {
                                      window
                                        .open(
                                          'https://api-passport.advanceagro.net/file/Training.xlsx',
                                          '_blank'
                                        )
                                        ?.focus();
                                    }}
                                    type="button"
                                    className="btn btn-tool"
                                  >
                                    <i className="fa fa-file-csv" />
                                  </button>
                                </div>
                              </div>
                              <div
                                className={
                                  stepTrainer === 1
                                    ? 'card-body'
                                    : 'card-body d-none'
                                }
                              >
                                <Form.Group className="mb-3 col-md-9">
                                  <Form.Control
                                    type="file"
                                    accept=".xlsx, .xls"
                                    onChange={fileUpload3}
                                  />
                                </Form.Group>
                              </div>
                            </div>
                            <div
                              className={
                                stepTrainer === 2
                                  ? 'card card-primary'
                                  : 'card collapsed-card'
                              }
                            >
                              <div className="card-header">
                                <h3 className="card-title">
                                  ขั้นตอนที่ 2 : ตรวจความถูกต้อง
                                  [คนหลักคือคนแรกเสมอ]
                                </h3>
                              </div>
                              <div
                                className={
                                  stepTrainer === 2
                                    ? 'card-body'
                                    : 'card-body d-none'
                                }
                                style={{
                                  height: '56vh',
                                  width: '100%',
                                  overflowY: 'scroll'
                                }}
                              >
                                <Table striped>
                                  <thead>
                                    <tr>
                                      <th>#</th>
                                      <th>รหัสพนักงาน</th>
                                      <th>ชื่อ-สกุล</th>
                                      <th>คนหลัก</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {data3
                                      .sort((a, b) => {
                                        return a.IS_MAIN
                                          ? -1
                                          : b.IS_MAIN
                                          ? 1
                                          : 0;
                                      })
                                      .map((x, i) => (
                                        <tr key={`v-${i}`}>
                                          <td>{i + 1}</td>
                                          <td>{x['EMPID']}</td>
                                          <td>{x['NAME']}</td>
                                          <td>
                                            <input
                                              type="checkbox"
                                              checked={x['IS_MAIN']}
                                              onChange={(e) => {
                                                const _temp = data3.map(
                                                  (el: any) => {
                                                    if (el.EMPID === x['EMPID'])
                                                      return {
                                                        ...el,
                                                        IS_MAIN:
                                                          e.target.checked
                                                      };
                                                    else return el;
                                                  }
                                                );

                                                setData3(_temp);
                                                setTraining(
                                                  (prevState: any) => ({
                                                    ...prevState,
                                                    TRAINER: _temp
                                                  })
                                                );
                                              }}
                                            />
                                          </td>
                                        </tr>
                                      ))}
                                  </tbody>
                                </Table>

                                <div className="row mt-2">
                                  <Button
                                    className="col-md-12"
                                    variant="warning"
                                    block
                                    type="button"
                                    onClick={handleReupload}
                                  >
                                    {'ไม่ถูกต้อง, อัพโหลดใหม่'}
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="related" title="Related HRD (9)">
                      <div className="container-fluid">
                        <div className={'card card-primary'}>
                          <div className="card-header">
                            <h3 className="card-title">
                              รายการนี้จะให้เห็นกับ Admin, Owner, และ Related
                              HRD เท่านั้น (ไม่ต้องเพิ่มตัวเอง)
                            </h3>
                          </div>
                          <div className={'card-body'}>
                            <div className="row">
                              <div className="col-6">
                                <Card className="card">
                                  <Card.Header className="d-flex">
                                    ค้นจากชื่อ รหัสพนักงาน หรืออีเมล์
                                  </Card.Header>
                                  <Card.Body>
                                    <div className="col-12 mb-1">
                                      <div className="ml-auto row">
                                        <div className="input-group">
                                          <input
                                            value={search2}
                                            type="text"
                                            onChange={(event) => {
                                              event.preventDefault();
                                              setSearch2(event.target.value);
                                            }}
                                            className="form-control"
                                            placeholder="ชื่อหรือรหัสพนักงาน"
                                          />
                                          <div className="input-group-append">
                                            <button
                                              className="btn btn-outline-secondary"
                                              type="button"
                                              onClick={onSearch2}
                                            >
                                              ค้นหา
                                            </button>
                                          </div>
                                          <div className="input-group-append">
                                            <button
                                              className="btn btn-success"
                                              type="button"
                                              onClick={onHistory}
                                            >
                                              ดึง Related ล่าสุดของฉัน
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="col-12 p-1 container"
                                      style={{
                                        height: '39vh',
                                        width: '100%',
                                        overflowY: 'scroll'
                                      }}
                                    >
                                      {members2.map((e, i) => (
                                        <ItemMember
                                          onAdd={onAdd}
                                          onDelete={onDelete}
                                          mode={'add'}
                                          key={`m-${i}`}
                                          name={e.DisplayName}
                                          empid={e.ID_Emp}
                                          img={e.Image}
                                          index={i + 1}
                                        />
                                      ))}
                                    </div>
                                  </Card.Body>
                                </Card>
                              </div>
                              <div className="col-6">
                                <Card className="card">
                                  <Card.Header className="d-flex">
                                    สมาชิกปัจจุบัน
                                  </Card.Header>
                                  <Card.Body>
                                    <div
                                      className="col-12 p-1 container"
                                      style={{
                                        height: '44vh',
                                        width: '100%',
                                        overflowY: 'scroll'
                                      }}
                                    >
                                      {members.map((e, i) => (
                                        <ItemMember
                                          onAdd={onAdd}
                                          onDelete={onDelete}
                                          mode={'delete'}
                                          key={`m-${i}`}
                                          name={e.DisplayName}
                                          empid={e.ID_Emp}
                                          img={e.Image}
                                          index={i + 1}
                                        />
                                      ))}
                                    </div>
                                  </Card.Body>
                                </Card>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab>
                  </Tabs>
                  <p
                    className="text-danger col-md-12 content"
                    dangerouslySetInnerHTML={{__html: error}}
                  ></p>
                </Card.Body>
                <Card.Footer>
                  <Button variant="success" onClick={handleSubmit}>
                    สร้างหลักสูตร
                  </Button>
                  {/* {temp} */}
                </Card.Footer>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TrainingMake;
